<script>
import { BModal } from 'bootstrap-vue'

export default {
    name: 'ChangeLogModal',
    components: {
        ChangeLog: () => import("@core/components/common/changelog/ChangeLog.vue"),
        BModal
    },
    props: {
        label: {
            default() {
                return this.$t('Component(ChangeLog):label');
            }
        },
        relationsLabel: {
            default() {
                return this.$t('Component(ChangeLog):relations-label');
            }
        },
        namespace: {
            required: true
        },
        businessObject: {
            required: true
        },
        primaryKey: {
            required: true
        },
        relations: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    methods: {
        show() {
            this.$refs['change-log-modal'].show();
        },
    },
}
</script>

<template>
    <b-modal
        ref="change-log-modal"
        cancel-variant="outline-secondary"
        body-class="p-0"
        hide-header
        size="lg"
        :ok-title="$t('Component(Button):close')"
        centered
        ok-only
    >
        <ChangeLog
            :label="label"
            :relations-label="relationsLabel"
            :namespace="namespace"
            :business-object="businessObject"
            :primary-key="primaryKey"
            :relations="relations"
        />
    </b-modal>
</template>
